import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { onCategory, onAttributeList, onCategoryAttributeCreate, 
  onBrandList, onCategoryBrandCreate, onAddAttributeChoiceToCategory, 
  onAttributeChoiceList, onCategoryAttributeChoiceList, 
  onUnlinkAttributeFromCategorySubmit, onRemoveAttributeChoiceFromCategory, onCategoryLeafAttributeChoices,
  onCategorySubmit, onCategoryLeafAttributeChoice, onCategoryDelete, onCategorySearch} from "../../controller/CategoryController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, Table, 
  Tabs, Tab, Modal } from 'react-bootstrap';
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { CategoryModel } from "../../dto/category/CategoryModel";
import { FileModel } from "../../dto/FileModel";
import Delete from '@mui/icons-material/Delete';
import Add from '@mui/icons-material/Add';
import { AttributeChoiceEntity } from "../../dto/attribute/AttributeChoiceEntity";
import { AttributeEntity } from "../../dto/attribute/AttributeEntity";
import { BrandEntity } from "../../dto/brand/BrandEntity";
import Select from 'react-select';
import { CategoryAttributeChoiceEntity } from "../../dto/category/CategoryAttributeChoiceEntity";
import { LeafModel } from "../../dto/category/LeafModel";
import { AttributeChoiceModel } from "../../dto/attribute/AttributeChoiceModel";
import { CategoryAttributeEntity } from "../../dto/category/CategoryAttributeEntity";

type CategoryParams = {
    categoryId: string;
};

const CategoryDetail = () => {
  const urlParam = useParams<CategoryParams>();
  const [key, setKey] = useState('attributeTab');
  const linkAttributeForm = useRef<HTMLFormElement>(null);
  const addAttributeChoiceForm = useRef<HTMLFormElement>(null);
  const addBrandForm = useRef<HTMLFormElement>(null);

  const handleReset = (form: string) => {
    if (form === 'linkAttributeForm') {
      if (linkAttributeForm.current !== null) {
        linkAttributeForm.current.reset();
      }
    } else if (form === 'addAttributeChoiceForm') {
      if (addAttributeChoiceForm.current !== null) {
        addAttributeChoiceForm.current.reset();
      }
    } else if (form === 'addBrandForm') {
      if (addBrandForm.current !== null) {
        addBrandForm.current.reset();
      }
    }
  };

  // form references
  const fileRef = useRef<HTMLInputElement>(null);
  const categoryAttributeRequiredRef = useRef<HTMLSelectElement>(null);
  const categoryAttributeMultipleRef = useRef<HTMLSelectElement>(null);

  // CATEGORY
  const categoryEntity: CategoryEntity = {
  }
  const [category, setCategory] = useState<CategoryModel>({
    action: 'update',
    entity: categoryEntity
  });
  const [categoryPhoto, setCategoryPhoto] = useState<FileModel>({
    id: undefined,
    data: undefined
  });

  // ALL ATTRIBUTES
  const [attributeList, setAttributeList] = useState<Array<AttributeEntity>>([]);

  // ALL BRANDS
  const [brandList, setBrandList] = useState<Array<BrandEntity>>([]);

  // LINK ATTRIBUTE TO CATEGORY
  const categoryAttributeEntity: CategoryEntity = {
  }
  const [categoryAttribute, setCategoryAttribute] = useState<CategoryModel>({
    action: 'link-attribute',
    entity: categoryAttributeEntity
  });

  // UNLINK ATTRIBUTE TO CATEGORY
  const unlinkAttributeEntity: CategoryEntity = {
  }
  const [unlinkAttribute, setUnlinkAttribute] = useState<CategoryModel>({
    action: 'unlink-attribute',
    entity: unlinkAttributeEntity
  });

  // CATEGORY BRAND CREATE
  const categoryBrandEntity: CategoryEntity = {
  }
  const [categoryBrand, setCategoryBrand] = useState<CategoryModel>({
    action: 'add-brand',
    entity: categoryBrandEntity
  });

  // CATEGORY ATTRIBUTE CHOICE CREATE
  const categoryAttributeChoiceEntity: CategoryEntity = {
  }
  const [categoryAttributeChoice, setCategoryAttributeChoice] = useState<CategoryModel>({
    action: 'attribute-add-choice',
    entity: categoryAttributeChoiceEntity
  });

   // REMOVE ATTRIBUTE CHOICE FROM CATEGORY
   const removeAttributeChoiceEntity: CategoryEntity = {
  }
  const [removeAttributeChoice, setRemoveAttributeChoice] = useState<CategoryModel>({
    action: 'attribute-remove-choice',
    entity: removeAttributeChoiceEntity
  });

  // CATEGORY BRAND LIST
  const [categoryBrandList, setCategoryBrandList] = useState<Array<BrandEntity>>([]);

  const [attributeChoice, setAttributeChoice] = useState<AttributeChoiceEntity>({
    id: undefined,
    attributeId: undefined,
    valueText: ''
  });

  // LEAF ATTRIBUTE
  const leafAttributeEntity: CategoryEntity = {
  }

  const [leafAttribute, setLeafAttribute] = useState<LeafModel>({
    action: 'leaf-add-attribute',
    entity: leafAttributeEntity
  })

  // New attribute modal
  const [newAttributeModalShow, setNewAttributeModalShow] = useState(false);
  const handleNewAttributeModalClose = () => setNewAttributeModalShow(false);

  // New brand modal
  const [newBrandModalShow, setNewBrandModalShow] = useState(false);
  const handleNewBrandModalClose = () => setNewBrandModalShow(false);

  // New attribute choice modal
  const [newAttributeChoiceModalShow, setNewAttributeChoiceModalShow] = useState(false);
  const handleNewAttributeChoiceModalClose = () => setNewAttributeChoiceModalShow(false);

  const [categoryOptions, setCategoryOptions] = useState<Array<Object>>([]);

  const navigate = useNavigate();

  // first render
  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    } else {
        categoryDetailGet();
        attributeListGet();
        brandListGet();
    }
  }, []) 

  // attribute choice update
  const categoryDetailGet = async () => {
    const categoryResponse = await onCategory(urlParam.categoryId || "");
    if (categoryResponse.status === 0) {
      if (categoryResponse.data.totalElements > 0) {
        // category
        const currentCategory: CategoryEntity = categoryResponse.data.beans[0];
        setCategory({
          ...category,
          entity: currentCategory
        });
        const categoryLinkedAttributes = await onAttributeList(currentCategory.id);
        console.log(categoryLinkedAttributes)
        if (categoryLinkedAttributes.status === 0) {
          // linked attributes
          const linkedAttributes: Array<AttributeEntity> = categoryLinkedAttributes.data.beans;
          for (var i = 0; i < linkedAttributes.length; i++) {
            var choiceArr: Array<AttributeChoiceEntity> = [];

            const categoryAttributeChoices = await onCategoryAttributeChoiceList(currentCategory.id, linkedAttributes[i].id);
            if (categoryAttributeChoices.status === 0) {
              const choices: Array<CategoryAttributeChoiceEntity> = categoryAttributeChoices.data.beans;
              if (choices !== undefined) {
                for (var j = 0; j < choices.length; j++) {
                  const choice = await onAttributeChoiceList(undefined, undefined, choices[j].attributeChoiceId);
                  if (choice.status === 0) {
                    if (choice.data.beans.length > 0) {
                      choiceArr.push(choice.data.beans[0]);
                    }
                  }
                }
              }
            }
            linkedAttributes[i].choices = choiceArr;
          }
          const prevState = {...categoryAttribute.entity};
          prevState.attributes = linkedAttributes;

          // const prevStateCategoryAttribute: CategoryAttributeEntity = prevState.categoryAttribute;

          // if (categoryAttributeRequiredRef.current !== null) {
          //   if (categoryAttributeRequiredRef.current.value == 'true') {
          //       prevState.categoryAttribute!.requiredFlag = true;
          //   } else {
          //     prevState.categoryAttribute!.requiredFlag = false;
          //   }
          // }

          // if (categoryAttributeMultipleRef.current !== null) {
          //   if (categoryAttributeMultipleRef.current.value == 'true') {
          //       prevState.categoryAttribute!.multipeAllowed = true;
          //   } else {
          //     prevState.categoryAttribute!.multipeAllowed = false;
          //   }
          // }

          setCategoryAttribute({
            ...categoryAttribute,
            entity: prevState
          });
        }

        // this category parent how many children?
        if (currentCategory.parentId != null) {
          const leafAvailableAttributeResponse = await onCategoryLeafAttributeChoices(urlParam.categoryId!);
          if (leafAvailableAttributeResponse.status === 0) {
            var bean: Array<AttributeChoiceEntity> = leafAvailableAttributeResponse.data.beans;
            const prevState = {...leafAttribute.entity};
            prevState.attributeChoices = bean;
            setLeafAttribute({
              ...leafAttribute,
              entity: prevState
            });
          }
        }
        const categoryAddedBrands = await onBrandList(currentCategory.id);
        if (categoryAddedBrands.status === 0) {
          const addedBrands: Array<BrandEntity> = categoryAddedBrands.data.beans;
          setCategoryBrandList(addedBrands);
        }
      } else {
        // NO DETAIL
      }
    }
  }

  const attributeListGet = async () => {
    const attributeList = await onAttributeList();
    setAttributeList(attributeList.data.beans);
  }

  const brandListGet = async () => {
    const brandList = await onBrandList();
    setBrandList(brandList.data.beans);
  }

  // category update
  const categoryUpdateSubmit = async (event: React.FormEvent) => {
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
        // action
        categorySubmit(event);
    }
  }

  const categorySubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
        // const response = await onCategorySubmit(category, categoryPhoto);
        // if (response !== undefined) {
        //   if (response.status === 0) {
        //       toast.success(response.msg);
        //       categoryDetailGet();
        //   } else {
        //       toast.error(response.msg);
        //   }
        // }
    } catch(e: any) {
        toast.error("Амжилтгүй");
    }
    if (fileRef.current !== null) {
      fileRef.current.value = "";
    }
  }

  // category brand create
  const categoryBrandCreateSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // action
      // const response = await onCategoryBrandCreate(categoryBrand);
      // if (response !== undefined) {
      //   if (response.status === 0) {
      //       toast.success(response.msg);
      //       handleReset('addBrandForm');
      //       handleNewBrandModalClose();
      //       categoryDetailGet();
      //   } else {
      //       toast.error(response.msg);
      //       let err = Object.entries(response.errors)
      //       err.map( ([key, val]) => {
      //         toast.error(key + ": " + val);
      //       });
      //   }
      // }
    }
  }

  // link attribute to category
  const linkAttributeToCategory = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // action
      console.log(categoryAttribute)
      // const response = await onCategoryAttributeCreate(categoryAttribute);
      // if (response !== undefined) {
      //   if (response.status === 0) {
      //       toast.success(response.msg);
      //       handleReset('linkAttributeForm');
      //       handleNewAttributeModalClose();
      //       categoryDetailGet();
      //   } else {
      //       toast.error(response.msg);
      //       let err = Object.entries(response.errors)
      //       err.map( ([key, val]) => {
      //         toast.error(key + ": " + val);
      //       });
      //   }
      // }
    }
  }

  // category attribute choice create
  const addAttributeChoiceToCategory = async (event: React.FormEvent) => {
    event.preventDefault();
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      // action
      // const response = await onAddAttributeChoiceToCategory(categoryAttributeChoice);
      // if (response !== undefined) {
      //   if (response.status === 0) {
      //       toast.success(response.msg);
      //       handleReset('addAttributeChoiceForm')
      //       handleNewAttributeChoiceModalClose();
      //       categoryDetailGet();
      //   } else {
      //       toast.error(response.msg);
      //       let err = Object.entries(response.errors)
      //       err.map( ([key, val]) => {
      //         toast.error(key + ": " + val);
      //       });
      //   }
      // }
    }
  }

  const CategoryAttributeChoiceSubmit = async (attrbtId: number) => {
    for (var i = 0; i < categoryAttribute.entity.attributes!.length; i++) {
      const categoryLinkedAttributeChoices = await onAttributeChoiceList(undefined, attrbtId);
      if ( categoryLinkedAttributeChoices.status === 0) {
        const cats: Array<AttributeChoiceEntity> = categoryLinkedAttributeChoices.data.beans;
        const optionArray: Array<Object> = [];
        cats.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.valueText
            }
            optionArray.push(obj);
        })
        setCategoryOptions(optionArray);
      }
    }

    const prevState = {...categoryAttributeChoice.entity};
    prevState.id = parseInt(urlParam.categoryId!);
    prevState.attribute!.id = attrbtId;
    setCategoryAttributeChoice({
      ...categoryAttributeChoice,
      entity: prevState
    });
    setNewAttributeChoiceModalShow(true);
  }

  const attributeChoicePicker = (value: Object) => {
    var choices: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
    
    var choiceArray: Array<AttributeChoiceEntity> = [];
    choices.map((choiceId, choiceIdIdx) => {
      var choice: AttributeChoiceEntity = {
        id: choiceId,
        attributeId: undefined,
        valueText: ''
      }
      choiceArray.push(choice);
    });
    
    const prevState: CategoryEntity = {...categoryAttributeChoice.entity};
    prevState.attribute!.choices! = choiceArray;
    setCategoryAttributeChoice({
        ...categoryAttributeChoice,
        entity: prevState
    });
  }

  const unlinkAttributeFromCategory = (categoryId: number, attributeId: number) => {
    if (window.confirm("Are you sure?")) {
      const prevState = {...unlinkAttribute.entity};
      prevState.id = categoryId;
      prevState.attribute!.id = attributeId;
      setUnlinkAttribute({
        ...unlinkAttribute,
        entity: prevState
      })
    }
  }

  useEffect(() => {
    if (unlinkAttribute.entity.id !== undefined && unlinkAttribute.entity.attribute!.id !== undefined) {
      unlinkAttributeFromCategorySubmit();
    }
  }, [unlinkAttribute]);

  const unlinkAttributeFromCategorySubmit = async () => {
    // action
    const response = await onUnlinkAttributeFromCategorySubmit(unlinkAttribute);
    if (response !== undefined) {
      if (response.status === 0) {
          toast.success(response.msg);
          categoryDetailGet();
      } else {
          toast.error(response.msg);
          let err = Object.entries(response.errors)
          err.map( ([key, val]) => {
            toast.error(key + ": " + val);
          });
      }
    }
  }

  const removeAttributeChoiceFromCategory = (categoryId: number, attributeId: number, choiceId: number) => {
    if (window.confirm("Are you sure?")) {
      const prevState = {...removeAttributeChoice.entity};
      prevState.id = categoryId;
      prevState.attribute!.id = attributeId;

      var choice: AttributeChoiceEntity = {
        id: choiceId,
        attributeId: undefined,
        valueText: ''
      }
      var choices: Array<AttributeChoiceEntity> = [];
      choices.push(choice);
      prevState.attribute!.choices! = choices;
      setRemoveAttributeChoice({
        ...removeAttributeChoice,
        entity: prevState
      })
    }
  }

  useEffect(() => {
    if (removeAttributeChoice.entity.id !== undefined 
      && removeAttributeChoice.entity.attribute!.id !== undefined
      && removeAttributeChoice.entity.attribute!.choices!.length > 0) {
        removeAttributeChoiceFromCategorySubmit();
    }
  }, [removeAttributeChoice]);

  const removeAttributeChoiceFromCategorySubmit = async () => {
    // action
    // const response = await onRemoveAttributeChoiceFromCategorySubmit(removeAttributeChoice);
    // if (response !== undefined) {
    //   if (response.status === 0) {
    //       toast.success(response.msg);
    //       categoryDetailGet();
    //   } else {
    //       toast.error(response.msg);
    //       let err = Object.entries(response.errors)
    //       err.map( ([key, val]) => {
    //         toast.error(key + ": " + val);
    //       });
    //   }
    // }
  }

  // REMOVE ATTRIBUTE CHOICE FROM CATEGORY
  const removeBrandEntity: CategoryEntity = {
  }
  const [removeBrand, setRemoveBrand] = useState<CategoryModel>({
    action: 'remove-brand',
    entity: removeBrandEntity
  });

  const removeBrandFromCategory = (categoryId: number, brandId: number) => {
    if (window.confirm("Are you sure?")) {
      const prevState = {...removeBrand.entity};
      prevState.id = categoryId;
      prevState.brandId = brandId;
      setRemoveBrand({
        ...removeBrand,
        entity: prevState
      })
    }
  }

  useEffect(() => {
    if (removeBrand.entity.id !== undefined 
      && removeBrand.entity.brandId !== undefined) {
        removeBrandFromCategorySubmit();
    }
  }, [removeBrand]);

  const removeBrandFromCategorySubmit = async () => {
    // action
    // const response = await onRemoveBrandFromCategorySubmit(removeBrand);
    // if (response !== undefined) {
    //   if (response.status === 0) {
    //       toast.success(response.msg);
    //       categoryDetailGet();
    //   } else {
    //       toast.error(response.msg);
    //       let err = Object.entries(response.errors)
    //       err.map( ([key, val]) => {
    //         toast.error(key + ": " + val);
    //       });
    //   }
    // }
  }

  const leafActionAttributeChoice = async (categoryId: number, fromCategoryId: number, attributeChoiceId: number, action: string) => {
    if (action === 'duplicate') {
      const dto: AttributeChoiceModel = {
        action: "category-duplicate-choice",
        entity: {
          id: attributeChoiceId,
          toCategoryId: categoryId,
          fromCategoryId: fromCategoryId
        }
      }
      const response = await onCategoryLeafAttributeChoice(dto);
      if (response.status === 0) {
        toast.success(response.msg);
      } else {
        toast.error(response.msg);
      }
    } else {
      const dto: AttributeChoiceModel = {
        action: "category-move-choice",
        entity: {
          id: attributeChoiceId,
          toCategoryId: categoryId,
          fromCategoryId: fromCategoryId
        }
      }
      const response = await onCategoryLeafAttributeChoice(dto);
      if (response.status === 0) {
        toast.success(response.msg);
      } else {
        toast.error(response.msg);
      }
    }
  }

  const deleteCategory = async (categoryId: number) => {
    if (window.confirm("Are you sure?")) {
      const response = await onCategoryDelete(categoryId);
      if (response.status === 0) {
        toast.success(response.msg);
      } else {
        toast.error(response.msg);
      }
    }
  }

  return (
    <Container fluid>
      <div><Toaster position="top-right" reverseOrder={false}/></div>
      <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Категори</h3>
      <Row className="d-flex justify-content-center align-items-center mb-3">
        <Col md={12} lg={12} xs={12}>
          <Card>
            <Card.Header>
                <h5>Ерөнхий мэдээлэл</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={9} lg={9} xs={9}>
                  <Form onSubmit={categoryUpdateSubmit}>
                    <Row>
                      <Col md={4}>
                        <Form.Group className="mb-3" controlId="categoryName">
                            <Form.Label className="text-center">Нэр</Form.Label>
                            <Form.Control type="text" size="sm" value={category.entity.name || ""}
                            onChange={(event) => {
                              const prevState: CategoryEntity = {...category.entity};
                              prevState.name = event.target.value;
                              setCategory({
                                  ...category,
                                  entity: prevState
                              })
                            }}/>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3" controlId="categoryOrder">
                            <Form.Label className="text-center">Эрэмбэ</Form.Label>
                            {/* <Form.Control type="text" size="sm" value={category.entity.order?.toString() || ""}
                            onChange={(event) => {
                              const prevState: CategoryEntity = {...category.entity};
                              prevState.order = parseInt(event.target.value);
                              setCategory({
                                  ...category,
                                  entity: prevState
                              })
                            }}/> */}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <Form.Group controlId="categoryFile" className="mb-3">
                          <Form.Label>ЗУРАГ</Form.Label>
                          <Form.Control ref={fileRef} type="file" size="sm" accept="image/*" 
                          onChange = {(event: React.ChangeEvent<HTMLInputElement>) => setCategoryPhoto({
                            ...categoryPhoto,
                            data: event.target.files ? event.target.files.item(0) : null
                        })}/>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className="mb-3" controlId="categoryFreight">
                          <div style={{ paddingLeft: "1.25rem" }}>
                            <Form.Label className="text-center">Хүргэлттэй</Form.Label>
                            <Form.Switch
                              id="freight-switch"
                              label="Хүргэлттэй эсэх"
                              checked={category.entity.freightRequiredFlag ? true : false}
                              onChange={(event) => {
                                const prevState: CategoryEntity = {...category.entity};
                                prevState.freightRequiredFlag = event.target.checked;
                                setCategory({
                                    ...category,
                                    entity: prevState
                                })
                              }}/>
                            </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                          <Form.Group className="mb-3">
                            <Button variant="primary" type="submit" size="sm">
                              Хадгалах
                            </Button>
                          </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col md={3} lg={3} xs={3}>
                  <span><b>Категори иерархи бүтэц</b></span>
                  {/* <Table>
                    <tbody>
                      {
                        categoryParents.map((parent, parentIdx) => {
                          return (
                              <tr key={parentIdx}>
                                  <th><a href={`/category/${parent.id}`}>{parent.name}</a></th>
                              </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>  */}
                  <ul>
                      {/* {
                        categoryParents.map((parent, parentIdx) => {
                          return (
                            <li key={parentIdx}>
                              <a href={`/category/${parent.id}`}>{parent.name}</a>
                              <div style={{ borderLeft: "6px solid green", height: "20px" }}></div>
                            </li>
                          )
                        })
                      } */}
                  </ul>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                if (k != null) {
                  setKey(k)
                }
              }}
              className="mb-3">
              {/* ATTRIBUTE TAB */}
              <Tab eventKey="attributeTab" title="Attribute">
                <Row>
                  <Col md={12} lg={12} xs={12}>
                    <Button variant="outline-primary" 
                      size="sm" 
                      onClick={() => {
                        const prevState: CategoryEntity = {...categoryAttribute.entity};
                        prevState.id = parseInt(urlParam.categoryId!);
                        setCategoryAttribute({
                            ...categoryAttribute,
                            entity: prevState
                        })
                        setNewAttributeModalShow(true);
                      }}> Атрибут холбох </Button>
                    <Table hover bordered>
                      <thead>
                        <tr>
                          <th>Нэр</th>
                          <th>Төрөл</th>
                          <th>Хэрэглэгчээс баталгаажуулах шаардлагатай</th>
                          <th>Дор хаяж нэг сонголт оруулах шаардлагатай</th>
                          <th>Олон сонголттой байж болно</th>
                          <th>Утга</th>
                        </tr>
                      </thead>
                      <tbody>
                          {
                            categoryAttribute.entity.attributes &&
                            categoryAttribute.entity.attributes.map((attrbt, attrbtIdx) => {
                              return (
                                <tr key={attrbtIdx}>
                                    <td>
                                      <span>
                                        <a style={{ float: "left" }} 
                                          onClick={() => unlinkAttributeFromCategory(parseInt(urlParam.categoryId!), parseInt(`${attrbt.id}`))}>
                                          <Delete />
                                        </a>
                                      </span>
                                      {attrbt.name}
                                      </td>
                                    <td>{attrbt.dataType}</td>
                                    <td>{attrbt.verificationRequired == true ? "Тийм" : "Үгүй"}</td>
                                    {/* <td>{attrbt.requiredFlag == true ? "Тийм" : "Үгүй"}</td>
                                    <td>{attrbt.multipleAllowed == true ? "Тийм" : "Үгүй"}</td> */}
                                    <td>
                                      {
                                        attrbt.choices !== null &&
                                        attrbt.choices!.map((choice, choiceIdx) => {
                                          return (
                                            <Row key={`${attrbtIdx}-${choiceIdx}`}>
                                              <span>
                                                - {choice.valueText}
                                                <a onClick={() => removeAttributeChoiceFromCategory(parseInt(urlParam.categoryId!), parseInt(`${attrbt.id}`), parseInt(`${choice.id}`))}
                                                style={{ float: "right" }}>
                                                  <Delete /> 
                                                </a>
                                              </span> 
                                            </Row>
                                          )
                                        })
                                      }
                                      <p>
                                        - <a onClick={() => CategoryAttributeChoiceSubmit(parseInt(`${attrbt.id}`))}>
                                            <Add />
                                          </a>
                                      </p>
                                    </td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Tab>
              {/* BRAND TAB */}
              <Tab eventKey="brandTab" title="Brand">
                <Row>
                  <Col md={12} lg={12} xs={12}>
                    <Button variant="outline-primary" 
                      size="sm" 
                      onClick={() => {
                        const prevState: CategoryEntity = {...categoryBrand.entity};
                        prevState.id = parseInt(urlParam.categoryId!);
                        setCategoryBrand({
                            ...categoryBrand,
                            entity: prevState
                        })
                        setNewBrandModalShow(true);
                      }}>
                        Брэнд нэмэх
                    </Button>
                    <Table hover bordered>
                      <thead>
                          <tr>
                              <th>Нэр</th>
                          </tr>
                      </thead>
                      <tbody>
                          {
                            categoryBrandList.map((brand, brandIdx) => {
                              return (
                                <tr key={brandIdx}>
                                  <td>
                                    <span>
                                      <a style={{ float: "left" }} 
                                        onClick={() => removeBrandFromCategory(parseInt(urlParam.categoryId!), parseInt(`${brand.id}`))}>
                                        <Delete />
                                      </a>
                                    </span>
                                    {brand.name}  
                                  </td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Tab>
              {/* <Tab eventKey="profile" title="Profile">
                Profile
              </Tab> */}
              <Tab eventKey="leafAttributeTab" title="Other Leaf Attribute">
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <Table hover bordered>
                        <thead>
                          <tr>
                            <th>Категори</th>
                            <th>Атрибут нэр</th>
                            <th>Атрибут төрөл</th>
                            <th>Атрибут утга</th>
                            <th>Duplicate</th>
                            <th>Move</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            leafAttribute.entity.attributeChoices &&
                            leafAttribute.entity.attributeChoices.map((attrbtChoice, attrbtChoiceIdx) => {
                              return (
                                <tr key={attrbtChoiceIdx}>
                                    <td>{attrbtChoice.categoryName} {attrbtChoice.categoryId}</td>
                                    <td>
                                      {attrbtChoice.attrbtName} {attrbtChoice.id}
                                      </td>
                                      <td>{attrbtChoice.attrbtType}</td>
                                      <td>{attrbtChoice.valueText}</td>
                                      <td>
                                      <span>
                                        <a style={{ float: "left" }} 
                                          onClick={() => leafActionAttributeChoice(parseInt(urlParam.categoryId!), attrbtChoice.categoryId!, parseInt(`${attrbtChoice.id}`), 'duplicate')}>
                                          <Add />
                                        </a>
                                      </span>
                                      </td>
                                      <td>
                                      <span>
                                        <a style={{ float: "left" }} 
                                          onClick={() => leafActionAttributeChoice(parseInt(urlParam.categoryId!), attrbtChoice.categoryId!, parseInt(`${attrbtChoice.id}`), 'move')}>
                                          <Add />
                                        </a>
                                      </span>
                                    </td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </Table>
                  </Col>
                </Row>
              </Tab>
              <Tab eventKey="deleteTab" title="Delete category">
                <Button variant="danger" type="button" size="sm" onClick={() => deleteCategory(parseInt(urlParam.categoryId!))}>
                  Устгах
                </Button>
              </Tab>
            </Tabs>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      {/* NEW ATTRIBUTE */}
      <Modal show={newAttributeModalShow} onHide={handleNewAttributeModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Атрибут холбох</Modal.Title>
        </Modal.Header>
        <Form onSubmit={linkAttributeToCategory} ref={linkAttributeForm}>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="categoryAttribute">
                  <Form.Label className="text-center">Атрибут</Form.Label>
                  <Form.Select size="sm"
                  onChange = {(event) => {
                    const prevState: CategoryEntity = {...categoryAttribute.entity};
                    const prevLinkAttributeState = {...prevState.attribute};
                    prevLinkAttributeState.id = parseInt(event.target.value);
                    prevState.attribute = prevLinkAttributeState;
                    setCategoryAttribute({
                        ...categoryAttribute,
                        entity: prevState
                    });
                  }}>
                    <option value=""></option>
                      {
                          attributeList.map((item, index) => {
                              return <option key={index}
                              value={item.id}>{item.name}</option>
                          })
                      }
                  </Form.Select>
                </Form.Group> 
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Form.Group className="mb-3" controlId="categoryAttributeRequiredFlag">
                    <Form.Label className="text-center">Дор хаяж нэг сонголттой байх</Form.Label>
                    <Form.Select ref={categoryAttributeRequiredRef} size="sm"
                      onChange = {(event) => {
                        const prevState: CategoryEntity = {...categoryAttribute.entity};
                        const prevLinkAttributeState = {...prevState.categoryAttribute};
                        if (event.target.value === 'true') {
                          prevLinkAttributeState.requiredFlag = true;
                        } else {
                          prevLinkAttributeState.requiredFlag = false;
                        }
                        prevState.categoryAttribute = prevLinkAttributeState;
                        setCategoryAttribute({
                            ...categoryAttribute,
                            entity: prevState
                        });
                      }}
                      required>
                        <option value="false">Шаардлагагүй</option>
                        <option value="true">Шаардлагатай</option>
                      </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Form.Group className="mb-3" controlId="categoryAttributeMultipleFlag">
                    <Form.Label className="text-center">Олон сонголт сонгох боломжтой</Form.Label>
                    <Form.Select ref={categoryAttributeMultipleRef} size="sm"
                      onChange = {(event) => {
                        const prevState: CategoryEntity = {...categoryAttribute.entity};
                        const prevLinkAttributeState = {...prevState.categoryAttribute};
                        if (event.target.value === 'true') {
                          prevLinkAttributeState.multipleAllowed = true;
                        } else {
                          prevLinkAttributeState.multipleAllowed = false;
                        }
                        prevState.categoryAttribute = prevLinkAttributeState;
                        setCategoryAttribute({
                            ...categoryAttribute,
                            entity: prevState
                        });
                      }}
                      required>
                        <option value="true">Тийм</option>
                        <option value="false">Үгүй</option>
                      </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNewAttributeModalClose}>
              Хаах
            </Button>
            <Button variant="primary" type="submit" size="sm">
              Хадгалах
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* NEW BRAND */}
      <Modal show={newBrandModalShow} onHide={handleNewBrandModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Брэнд нэмэх</Modal.Title>
        </Modal.Header>
        <Form onSubmit={categoryBrandCreateSubmit}
        ref={addBrandForm}>
          <Modal.Body>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Form.Group className="mb-3" controlId="categoryBrand">
                    <Form.Label className="text-center">Брэнд</Form.Label>
                    <Form.Select size="sm"
                    onChange = {(event) => {
                      const prevState: CategoryEntity = {...categoryBrand.entity};
                      prevState.brandId = parseInt(event.target.value);
                      setCategoryBrand({
                          ...categoryBrand,
                          entity: prevState
                      });
                      setNewBrandModalShow(true);
                    }} 
                    required>
                      <option value=""></option>
                        {
                            brandList.map((item, index) => {
                                return <option key={index}
                                value={item.id}>{item.name}</option>
                            })
                        }
                    </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNewBrandModalClose}>
              Хаах
            </Button>
            <Button variant="primary" type="submit" size="sm">
              Хадгалах
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* NEW ATTRIBUTE CHOICE */}
      <Modal show={newAttributeChoiceModalShow} onHide={handleNewAttributeChoiceModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Атрибут утга нэмэх</Modal.Title>
        </Modal.Header>
        <Form onSubmit={addAttributeChoiceToCategory}
        ref={addAttributeChoiceForm}>
          <Modal.Body>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <Form.Group controlId="attributeChoices">
                  <Form.Label>СОНГОЛТ</Form.Label>
                  <Select
                    options={categoryOptions}
                    onChange={attributeChoicePicker}
                    isMulti={true}
                    isClearable={true}
                    isSearchable={true}
                    isDisabled={false}
                    isLoading={false}
                    isRtl={false}
                    />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleNewAttributeChoiceModalClose}>
              Хаах
            </Button>
            <Button variant="primary" type="submit" size="sm">
              Хадгалах
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  )
}

export default CategoryDetail;